import { useEffect, useState } from "react"
import { getDepartamentoById, postDepartamento, patchDepartamento} from "../../services/DepartamentosServices"
import { DepartamentosFormContext } from "./DepartamentosContext"
import { useNavigate, useParams } from 'react-router-dom';

export const DepartamentosFormState = ({ children }) => {
    const [report, setReport] = useState({})
    const navigate = useNavigate();
    const { id } = useParams()

    useEffect(() => {
        if (id) getDepartamentoByIdData(id)
    }, [])

    const getDepartamentoByIdData = async (id) => {
        let res = await getDepartamentoById(id)
        if (res) setReport(res)
    }

    const postDepartamentoData = async (body) => {
        const res = await postDepartamento(body)
        if (res) navigate("/departamentos");
    }

    const patchDepartamentoData = async (id, body) => {
        const res = await patchDepartamento(id, body)
        if (res) navigate("/departamentos");
    }

    return <DepartamentosFormContext.Provider value={{
        report,
        postDepartamentoData,
        patchDepartamentoData,
    }} >
        {children}
    </DepartamentosFormContext.Provider>
}